// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__21V07","col":"styles_col__3zI_x"};